module.exports = __webpack_public_path__ + "static/media/Galeria_Familiares_12.41b0a20e.png";